<template>
    <div class="Transfer Card Card--top">
        <div class="Card-header">
            <button class="Card-headerControl Button Transfer-close" @click="$emit('close', true)">&times;</button>
            <h2 class="Card-title">Transfer options for Ticket {{ticket.code}}</h2>
        </div>
        <div class="Card-body">
            <h3>Guest name: {{ticket.name}}</h3>
            <p>Source event: {{ ticket.event.name }}, {{ticket.event.date}} ({{ticket.event.currency_symbol}}{{ ticket.event.price }}). {{ticket.quantity}} tickets.</p>
            <form @submit="transferTicket($event)">
                <input-field
                    :value="targetEventSearch"
                    :definition="{
                        fieldType: 'typeahead',
                        label: 'Event to transfer ticket to:',
                        url: 'events/search'
                    }"
                    @change="updateTypeaheadString($event)"
                    v-on:selected="updateTargetEvent($event)">
                </input-field>
                <p v-if="targetEvent">
                    Target event: {{targetEvent.id}}: {{targetEvent.name}}, {{targetEvent.date}} ({{targetEvent.currency_symbol}}{{targetEvent.price}})<br>
                    Tickets remaining: {{targetEvent.quantity - targetEvent.sold}}
                </p>
                <button
                    class="Button"
                    :disabled="isDisabled"
                    type="submit">Transfer ticket</button>

                <p v-if="asyncFormError" class="Error">{{asyncFormError}}</p>
                <a v-if="reissueTicketEmailUrl" :href="reissueTicketEmailUrl" target="_blank">Reissue ticket email with new event details</a>
            </form>
        </div>
    </div>
</template>

<script>
    import cookieModel from '../../models/cookie';
    import axios from "axios";
    import errorModel from "../../models/error";
    import InputField from '../input-field/input-field.vue';
    import './_Transfer.scss';

    export default {
        components: {
          InputField,
        },
        props: {
            ticket: Object,
        },
        computed: {
          isDisabled: function() {
              let isDisabled = false;
              const vm = this;
              vm.asyncFormError = '';
              console.log('check isDisabled');
              if (!this.targetEvent) {
                  vm.asyncFormError = 'Please select an event';
                  isDisabled = true;
              } else if (this.targetEvent.quantity - this.targetEvent.sold < 1) {
                  vm.asyncFormError = 'No tickets remaining for this event';
                  isDisabled = true;
              } else if (this.targetEvent.price !== this.ticket.event.price) {
                  vm.asyncFormError = 'Ticket price does not match event price';
                  isDisabled = true;
              }

              return isDisabled;
          }
        },
        methods: {
            transferTicket: function(e) {
                e.preventDefault();
                const vm = this;
                // Add authorisation to request header
                vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer '+ cookieModel.getCookie('ticketlab_access');

                // send transfer request to API
                let url = vm.baseUrl + '/einstein/ticket/transfer';
                let postData = {
                    ticketCode: vm.ticket.code,
                    eventId: vm.targetEvent.id,
                };

                vm.axiosInstance.post(url, postData)
                    .then(function(response) {
                        vm.asyncFormError = '';
                        if (response.data.status === 'error') {
                            vm.asyncFormError = response.data.reason;
                        } else {
                            vm.asyncFormError = 'Success!'
                            if (response.data.url) {
                                vm.reissueTicketEmailUrl = response.data.url;
                            }
                        }
                    }.bind(this))
                    .catch(function(error) {
                        vm.asyncFormError = errorModel.apiError(error, vm.$router);
                        console.log('error: ', error);
                        vm.asyncFormError = error.toString();
                    });
            },
            updateTypeaheadString: function(event) {
                console.log('update search string', event)
                // this.targetEventSearch = event;
            },
            updateTargetEvent: function(event) {
                this.targetEvent = event;
            }
        },
        data: function () {
            return {
                baseUrl: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : '/',
                axiosInstance: axios.create({
                    baseURL: this.baseUrl,
                }),
                targetEvent: false,
                targetEventSearch: '',
                asyncFormError: false,
                reissueTicketEmailUrl: false,
            }
        }
    }
</script>
